// PrivateRoute.js
import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { RoleEnum } from "../shared/model";

const PrivateRoute = () => {
  const { user, isAuthenticated } = useSelector((state: any) => state.auth);
  const location = useLocation();
  const isProfessional = Number(user?.role?.id) === RoleEnum.professional || Number(user?.role?.id) === RoleEnum.internationl_professional;
  const sendToDashboard = () => {
    if (Number(user?.role?.id) === RoleEnum.client) {
      return <Navigate to="/clients" replace />;
    }
    else if (isProfessional) {
      return <Navigate to="/professionals" replace />;
    }
    else if (Number(user?.role?.id) === RoleEnum.admin) {
      return <Navigate to="/admin" replace />;
    }
  };

  if (!user) {
    // Not logged in → redirect to login
    return <Navigate to="/auth/login" replace />;
  }

  // Restrict access to professional routes for non-professionals
  if (
    location.pathname.startsWith("/professionals") &&
    (Number(user?.role?.id) !== RoleEnum.professional &&
      Number(user?.role?.id) !== RoleEnum.internationl_professional)
  ) {
    alert("You are not professional.");
    return sendToDashboard();
  }

  // Restrict access to client routes for non-clients (optional)
  if (
    location.pathname.startsWith("/clients") &&
    (Number(user?.role?.id) !== RoleEnum.client &&
      Number(user?.role?.id) !== RoleEnum.admin)
  ) {
    alert("You are not client.");
    return sendToDashboard();
  }

  if (
    location.pathname.startsWith("/admin") &&
    Number(user?.role?.id) !== RoleEnum.admin
  ) {
    alert("You are not admin.");
    return sendToDashboard();
  }

  return <Outlet />;
};

export default PrivateRoute;
